import React, { useEffect, useRef, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";

export default function InventoryMessage(props) {

    const { controller = "", callback = () => { }, route = "", stock_id = "" } = props;

    const [note, setNote] = useState("");
    const messageRef = useRef(); 

    const saveNote = () => {
        pubCall("stock.saveNote", { stock_id: stock_id, message: note }, (_s, _r) => {
            if (_s) {
                showMessage("Note saved!", 2000, "success")
                callback();
            } else {
                showError(_r);
            }
        })
    }

    useEffect(() => {
        pubCall("stock.getNote", { stock_id: stock_id }, (_s, _r) => {
            if (_s) {
                setNote(_r);
            } else {
                showError(_r);
            }
        })
        messageRef.current.focus();

    }, []);
    useEffect(() => {
        const actions = [
            { key: KBD.ESCAPE, action: (e) => { callback() } },
            { key: KBD.PAGE_DOWN, action: (e) => { saveNote() } },
        ];
        const cleanup = listen(controller, route, actions, false, [KBD.ESCAPE, KBD.PAGE_DOWN]);
        return cleanup;
    }, [note]);

    return (
        <div style={{ "fontSize": "15px" }}>
            <div className="shim" /><div className="shim" />
            <textarea ref={messageRef} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Inventory note..." style={{ "fontSize": "14px" }} class="ui-textarea" rows="10" cols="73"></textarea>
            <Status><InfoIcon />Freeform notes. [{KBD.ESCAPE.label}] to exit. [{KBD.PAGE_DOWN.label}] to save.</Status>
        </div>
    )
}